// @flow strict-local

import * as React from 'react';

import classify from 'src/utils/classify';

import HappyCalendar from 'src/images/scheduler/happy-calendar.svg';
import css from './calendar.css';


type Props = {
  animationDelay?: number,
  className?: string,
};
export const CalendarLoader = ({
  className,
  animationDelay = 1_400,
}: Props): React.Node => {
  const [isWaiting, setIsWaiting] = React.useState(true);
  const timeoutId = React.useRef<?TimeoutID>(null);

  React.useEffect(() => {
    timeoutId.current = setTimeout(() => {
      setIsWaiting(false);
      timeoutId.current = null;
    }, animationDelay);

    return () => {
      if (timeoutId.current != null) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return animationDelay > 0 && !isWaiting ? (
    <AnimatedCalendar className={classify(css.calendar, className)} />
  ) : null;
};

const AnimatedCalendar = (props) => (
  <svg
    width="105"
    height="120"
    viewBox="0 0 105 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <mask id="eyes">
        <path
          d="M40.8571 69.0082C43.5715 69.0082 45.9643 66.7656 45.9643 63.8791C45.9643 61.1501 43.5766 58.75 40.8571 58.75C37.9808 58.75 35.75 61.1552 35.75 63.8791C35.75 66.7606 37.9859 69.0082 40.8571 69.0082ZM65.1429 58.75C62.2666 58.75 60.0357 61.1552 60.0357 63.8791C60.0357 66.7606 62.2716 69.0082 65.1429 69.0082C67.8573 69.0082 70.25 66.7656 70.25 63.8791C70.25 61.1501 67.8623 58.75 65.1429 58.75Z"
          strokeWidth="0.5"
          fill="white"
        />
        <g className="eyes">
          <path
            d="M40.8571 80.7582C43.4375 80.7582 45.7143 78.6236 45.7143 75.8791C45.7143 73.2871 43.4375 71 40.8571 71C38.125 71 36 73.2871 36 75.8791C36 78.6236 38.125 80.7582 40.8571 80.7582ZM65.1429 71C62.4107 71 60.2857 73.2871 60.2857 75.8791C60.2857 78.6236 62.4107 80.7582 65.1429 80.7582C67.7232 80.7582 70 78.6236 70 75.8791C70 73.2871 67.7232 71 65.1429 71Z"
            fill="black"
          />
        </g>
      </mask>
    </defs>

    <g className="illustration">
      <path
        d="M40.8571 69.0082C43.5715 69.0082 45.9643 66.7656 45.9643 63.8791C45.9643 61.1501 43.5766 58.75 40.8571 58.75C37.9808 58.75 35.75 61.1552 35.75 63.8791C35.75 66.7606 37.9859 69.0082 40.8571 69.0082ZM65.1429 58.75C62.2666 58.75 60.0357 61.1552 60.0357 63.8791C60.0357 66.7606 62.2716 69.0082 65.1429 69.0082C67.8573 69.0082 70.25 66.7656 70.25 63.8791C70.25 61.1501 67.8623 58.75 65.1429 58.75Z"
        strokeWidth="0.5"
        mask="url(#eyes)"
      />
      <path
        d="M68.5399 79.6431L68.5345 79.6382L68.5289 79.6337C66.9074 78.3306 64.48 78.4955 63.0254 80.1191L63.0205 80.1245L63.016 80.1302C60.6351 83.1197 56.9127 84.915 53.0419 84.915C49.3245 84.915 45.6014 83.1209 43.2196 80.1302L43.211 80.1194L43.2012 80.1096C41.7738 78.6757 39.3436 78.1532 37.6957 79.6431C36.0948 81.0904 35.7497 83.5305 37.2172 85.1743C41.0598 89.9573 46.8976 92.7336 53.0419 92.7336C59.3406 92.7336 65.0248 89.9553 69.0168 85.1761C70.4862 83.5323 70.1414 81.0909 68.5399 79.6431Z"
        strokeWidth="0.5"
      />
      <path d="M93.75 15H82.5V2.8125C82.5 1.40625 81.0938 0 79.6875 0L77.8125 0C76.1719 0 75 1.40625 75 2.8125V15L30 15V2.8125C30 1.40625 28.5938 0 27.1875 0L25.3125 0C23.6719 0 22.5 1.40625 22.5 2.8125V15L11.25 15C4.92188 15 0 20.1562 0 26.25L0 108.75C0 115.078 4.92188 120 11.25 120H93.75C99.8438 120 105 115.078 105 108.75V26.25C105 20.1562 99.8438 15 93.75 15ZM11.25 22.5L93.75 22.5C95.625 22.5 97.5 24.375 97.5 26.25V37.5L7.5 37.5V26.25C7.5 24.375 9.14063 22.5 11.25 22.5ZM93.75 112.5H11.25C9.14063 112.5 7.5 110.859 7.5 108.75L7.5 45L97.5 45V108.75C97.5 110.859 95.625 112.5 93.75 112.5Z" />
    </g>
  </svg>
);
